import React from "react";
import CustomPopup from "../../../../Common/CustomPopup";
import OutlineButton from "../../../../Common/Buttons/OutlineButton";
import styles from "./index.module.css";

const CancelDonePopup = ({ open, onClose, onGoHome, onBookAgain }) => {
  return (
    <CustomPopup
      open={open}
      onClose={onClose}
      maxWidth="md"
      className={styles.cancelDonePopup}
      showCloseButton={true}
      disableBackdropClick={false}
      padding="24px 40px"
    >
      <div className={styles.container}>
        <h2 className={styles.title}>Your trial class has been cancelled</h2>
        <p className={styles.body}>
          Plans change - we get it. Whenever you're ready, you can easily
          schedule another trial class and continue exploring Codeyoung.
        </p>
        <div className={styles.buttonRow}>
          <OutlineButton
            onClick={() => window.location.reload()}
            className={styles.homeBtn}
          >
            Go to home
          </OutlineButton>
          <OutlineButton
            onClick={onBookAgain}
            className={styles.bookBtn}
          >
            Book trial class again
          </OutlineButton>
        </div>
      </div>
    </CustomPopup>
  );
};

export default CancelDonePopup;
